import { render, staticRenderFns } from "./AvailableProducts.vue?vue&type=template&id=60da437b&scoped=true&"
import script from "./AvailableProducts.vue?vue&type=script&lang=js&"
export * from "./AvailableProducts.vue?vue&type=script&lang=js&"
import style0 from "./AvailableProducts.vue?vue&type=style&index=0&id=60da437b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da437b",
  null
  
)

export default component.exports